// src/lib/i18n.js
// ───────────────────────────────────────────────────────────────────────────
// 🌐 Shim de i18n (puente hacia PLAN-BILINGUE-ES-EN)
// Aún no hay react-i18next en el proyecto; este shim deja las CLAVES y ambos
// diccionarios listos desde hoy ("texto nuevo de UI usa t('key')"). Cuando
// llegue la librería, estos diccionarios se vuelcan a es.json/en.json y t()
// se reemplaza por el hook real — sin tocar los componentes.
// ───────────────────────────────────────────────────────────────────────────

const es = {
    // Materiales (vista unificada)
    'materials.title': 'Materiales',
    'materials.tab.materials': 'Materiales',
    'materials.tab.remnants': 'Retales',
    'materials.new': 'Nuevo Material',
    'materials.migrationLock.banner': 'Catálogo en migración: el alta/edición de materiales está temporalmente deshabilitado. El conteo de inventario (stock) sigue disponible.',
    'materials.search': 'Buscar por nombre o código…',
    'materials.allCategories': 'Todas las Categorías',
    'materials.allColors': 'Todos los Colores',
    'materials.allThicknesses': 'Todos los Espesores',
    'materials.allStock': 'Todo el Stock',
    'materials.stock.ok': 'OK',
    'materials.stock.low': 'Bajo',
    'materials.stock.out': 'Sin stock',
    'materials.stock.na': 'N/D',
    'materials.addStock': '+ Inventariar',
    'materials.addRemnant': '+ Retal',
    'materials.history': 'Historial de movimientos',
    'materials.edit': 'Editar',
    'materials.delete': 'Eliminar',
    'materials.deleteConfirm': '¿Estás seguro? Esta acción no se puede deshacer.',
    'materials.notInList': '¿No está en la lista? Avisar al administrador',
    'materials.notInList.prompt': 'Describe el material que falta (nombre, tipo, medidas):',
    'materials.notInList.sent': 'Aviso enviado al administrador. No registres el material tú mismo.',
    'materials.notInList.error': 'No se pudo enviar el aviso.',
    'materials.movePallet': 'Mover paleta',
    'materials.printLabel': 'Imprimir etiqueta',
    'materials.empty': 'No hay materiales que coincidan con los filtros.',
    'materials.loading': 'Cargando…',
    'materials.view.grid': 'Cuadrícula',
    'materials.view.list': 'Lista',
    'materials.unit.sheets': 'planchas',
    'materials.unit.rolls': 'rollos',
    'materials.unit.units': 'uds',
    'materials.col.photo': 'Foto',
    'materials.col.code': 'Código',
    'materials.col.name': 'Nombre',
    'materials.col.category': 'Categoría',
    'materials.col.presentation': 'Presentación',
    'materials.col.measures': 'Medidas',
    'materials.col.thickness': 'Espesor',
    'materials.col.color': 'Color',
    'materials.col.stock': 'Stock',
    'materials.col.location': 'Ubicación',
    'materials.col.notes': 'Notas',

    // Etiqueta de material (espejo de la de retal)
    'label.material.tag': 'MATERIAL',
    'label.stock': 'Existencia',
    'label.location': 'Ubicación',
    'label.date': 'Fecha',

    // Corrección de stock (ajuste audit-safe)
    'correct.wrong': '¿Cantidad equivocada? Corregir',
    'correct.label': 'Cantidad correcta (lo que debía ser)',
    'correct.apply': 'Aplicar corrección',
    'correct.applying': 'Corrigiendo…',
    'correct.done': 'Corregido a',
    'correct.invalid': 'Ingresa una cantidad válida (≥ 0).',
    'correct.error': 'No se pudo aplicar la corrección.',
    'correct.revert': 'Revertir',
    'correct.revertConfirm': '¿Revertir este movimiento? Se posteará un ajuste compensatorio (el historial se conserva).',

    // Entrada de stock (flujo obrero)
    'stock.title': 'Inventariar material',
    'stock.quantity': 'Cantidad (planchas/unidades)',
    'stock.notes': 'Notas (opcional)',
    'stock.save': 'Guardar entrada',
    'stock.saving': 'Guardando…',
    'stock.done': 'entrada(s) registrada(s) en',
    'stock.error': 'No se pudo registrar la entrada.',

    // Retales
    'remnant.title': 'Nuevo retal',
    'remnant.material': 'Material del catálogo',
    'remnant.materialNone': '— Sin material (categoría manual) —',
    'remnant.category': 'Categoría',
    'remnant.m1': 'Medida 1 (pulgadas)',
    'remnant.m1.flute': 'Medida 1 — DIRECCIÓN DE FLAUTA (pulgadas)',
    'remnant.m2': 'Medida 2 (pulgadas)',
    'remnant.fluteHint': 'Cartón corrugado: mide la pieza CON LA FLAUTA a lo largo de la Medida 1.',
    'remnant.quantity': 'Cantidad de piezas',
    'remnant.sourceJob': 'Job de origen (opcional)',
    'remnant.notes': 'Notas (opcional)',
    'remnant.photo': 'Foto (opcional)',
    'remnant.downloadDxf': 'Descargar DXF',
    'remnant.save': 'Guardar en inventario',
    'remnant.saving': 'Guardando…',
    'remnant.saved': 'Retal guardado:',
    'remnant.printLabel': 'Imprimir etiqueta',
    'remnant.close': 'Cerrar',
    'remnant.cancel': 'Cancelar',
    'remnant.error': 'No se pudo guardar el retal.',
    'remnant.invalidDims': 'Ingresa Medida 1 y Medida 2 (pulgadas, > 0).',
    'remnant.flute.badge': 'Flauta → M1',
    'remnant.status.available': 'Disponible',
    'remnant.status.reserved': 'Reservado',
    'remnant.status.used': 'Usado',
    'remnant.use': 'Usar',
    'remnant.useJobPrompt': '¿En qué job se usó? (opcional, ej. J-1042)',
    'remnant.search': 'Buscar por código o material…',
    'remnant.allStatuses': 'Todos los estados',
    'remnant.allLocations': 'Todas las ubicaciones',
    'remnant.col.code': 'Código',
    'remnant.col.material': 'Material',
    'remnant.col.measures': 'Medidas (in)',
    'remnant.col.qty': 'Cant.',
    'remnant.col.location': 'Ubicación',
    'remnant.col.status': 'Estado',
    'remnant.col.actions': 'Acciones',
    'remnant.totals': 'Totales por categoría:',
    'remnant.empty': 'No hay retales registrados todavía.',

    // Ubicación (§4b)
    'location.label': 'Ubicación',
    'location.type.pallet': 'Paleta',
    'location.type.rack': 'Rack',
    'location.type.zone': 'Zona de piso',
    'location.warehouse': 'Almacén',
    'location.pick.pallet': 'Elige la paleta…',
    'location.pick.rack': 'Elige el rack…',
    'location.pick.zone': 'Elige la zona…',
    'location.missing': 'Selecciona la ubicación de la lista.',
    'location.noneConfigured': 'No hay ubicaciones configuradas. Pide al administrador crear almacenes/racks/zonas.',
    'location.noPallets': 'No hay paletas creadas todavía. Usa Rack o Zona, o crea una paleta desde "Mover paleta".',

    // Mover paleta
    'pallet.move.title': 'Mover paleta',
    'pallet.move.which': 'Paleta',
    'pallet.move.pick': 'Elige la paleta…',
    'pallet.move.to': 'Nueva ubicación',
    'pallet.move.save': 'Mover',
    'pallet.move.moving': 'Moviendo…',
    'pallet.move.done': 'Paleta reubicada. Todo lo que está encima se movió con ella.',
    'pallet.move.error': 'No se pudo mover la paleta.',
    'pallet.move.firstPallet': 'Todavía no hay paletas. Elige una zona o rack abajo y crea la primera con "+ Nueva paleta".',
    'pallet.new': 'Nueva paleta',
    'pallet.new.prompt': 'Se creará una paleta nueva en la ubicación elegida.',
    'pallet.new.hint': 'Elige zona o rack arriba para habilitar "+ Nueva paleta".',
    'pallet.new.done': 'Paleta creada:',
    'pallet.qr.download': 'Descargar QR de la paleta',

    // Terminal de Operador (PLAN-TERMINAL-OPERADOR W2 · B1c)
    'terminal.title': 'Terminal de Operador',
    'terminal.subtitle': 'Escanea una plancha para registrar producción',
    'terminal.input.placeholder': 'Escanea el QR o teclea el código de la plancha…',
    'terminal.scanCamera': 'Escanear con cámara',
    'terminal.searching': 'Buscando…',
    'terminal.cameraTitle': 'Apunta la cámara al QR',
    'terminal.cameraClose': 'Cerrar cámara',
    'terminal.next': 'Escanear otra',
    'terminal.exit': 'Salir',
    'terminal.logout': 'Cerrar sesión',
    'terminal.job': 'Trabajo',
    'terminal.preview': 'Preview de la plancha',
    'terminal.action.prompt': '¿Qué acción registras?',
    'terminal.printedFront': 'Impresas (Frente)',
    'terminal.printed': 'Impresas',
    'terminal.printedBack': 'Impresas (Dorso)',
    'terminal.cutLabel': 'Cortadas',
    'terminal.markPrintFront': 'Impresa (Frente)',
    'terminal.markPrint': 'Marcar Impresa',
    'terminal.markPrintBack': 'Impresa (Dorso)',
    'terminal.markCut': 'Marcar Cortada',
    'terminal.reportFailure': 'Reportar Falla / Faltante',
    'terminal.allMarked': 'Todas las repeticiones ya están marcadas.',
    'terminal.piecesInSheet': 'Piezas en esta plancha',
    'terminal.success.print': '¡Listo! 1 repetición marcada como impresa (frente).',
    'terminal.success.printBack': '¡Listo! 1 repetición marcada como impresa (dorso).',
    'terminal.success.cut': '¡Listo! 1 repetición marcada como cortada.',
    'terminal.success.report': 'Reporte enviado y asignado.',
    'terminal.error.generic': 'No se pudo registrar la producción.',
    'terminal.error.notfound': 'No se encontró ninguna plancha ni pieza con ese código.',
    'terminal.error.artifact': 'Eso es una etiqueta de ARCHIVO. Úsala en el Buscador de Archivos.',
    'terminal.error.unknown': 'Código no reconocido. Escanea el QR de una plancha o pieza.',
    'terminal.error.sheetGone': 'La plancha del código ya no existe.',
    'terminal.candidates.sheets': 'Varias planchas coinciden. Elige una:',
    'terminal.candidates.pieces': 'La pieza está en varios trabajos. Elige uno:',
    'terminal.piece.title': 'Pieza (consulta)',
    'terminal.piece.required': 'Requeridas',
    'terminal.piece.printed': 'Impresas',
    'terminal.piece.cut': 'Cortadas',
    'terminal.piece.status': 'Estado',
    'terminal.piece.inSheets': 'En planchas',
    'terminal.piece.readonly': 'Vista de solo lectura. La producción se registra escaneando la PLANCHA.',

    // Catálogo de materiales — atributos por familia (PLAN-CATALOGO-MATERIALES §3 · Slice 1)
    'matAttr.presentation': 'Presentación',
    'matAttr.dimensions': 'Dimensiones',
    'matAttr.brand': 'Marca',
    'matAttr.supplier': 'Proveedor',
    'matAttr.price': 'Precio',
    'matAttr.imageUrl': 'Imagen',
    'matAttr.flute': 'Flauta',
    'matAttr.test': 'Test / ECT',
    'matAttr.outerLiner': 'Liner exterior',
    'matAttr.innerLiner': 'Liner interior',
    'matAttr.medium': 'Médium (centro)',
    'materials.tx.consumption': 'Salida por Consumo',
    'matAttr.coating': 'Recubrimiento',
    'matAttr.caliper': 'Calibre (PT)',
    'matAttr.color': 'Color',
    'matAttr.thickness': 'Espesor',
    'matAttr.subtype': 'Subtipo',
    'matAttr.type': 'Tipo',
    'matAttr.finish': 'Acabado',
    'matAttr.outerFace': 'Cara exterior',
    'matAttr.coreFace': 'Cara del panal (centro)',
    'matAttr.innerFace': 'Cara interior',
    // Catálogo de materiales — familias (categorías) — 6 familias §3.2
    'matCat.CORRUGATED': 'Corrugado',
    'matCat.HONEYCOMB': 'Panal (honeycomb)',
    'matCat.RIGID': 'Lámina rígida',
    'matCat.FLUTED_PLASTIC': 'Plástico corrugado',
    'matCat.PAPERBOARD': 'Cartulina',
    'matCat.WOOD': 'Madera',
    // Catálogo de materiales — mensajes de validación
    'matValid.unknownCategory': 'Categoría no reconocida.',
    'matValid.required': 'Campo obligatorio.',
    'matValid.enum': 'Valor fuera de los permitidos.',
    'matValid.range': 'El espesor está fuera del rango de la familia.',
    'matValid.unit': 'Unidad de espesor incorrecta para la familia.',
    'matValid.numeric': 'Debe ser un número.',

    // Modal dinámico de material (Slice 4)
    'matModal.newTitle': 'Nuevo material',
    'matModal.editTitle': 'Editar material',
    'matModal.category': 'Categoría',
    'matModal.width': 'Ancho',
    'matModal.height': 'Alto / Largo',
    'matModal.previewTitle': 'Vista previa (generado por el servidor)',
    'matModal.code': 'Código',
    'matModal.codeAuto': '(se asignará al guardar)',
    'matModal.displayName': 'Nombre',
    'matModal.specCode': 'Spec code',
    'matModal.save': 'Guardar material',
    'matModal.saving': 'Guardando…',
    'matModal.cancel': 'Cancelar',
    'matModal.imageHint': '…o pega una imagen (Ctrl+V) en esta ventana.',
    'matModal.dupTitle': 'Ya existe un material con esta identidad.',
    'matModal.dupStock': 'stock',
    'matModal.dupAddStock': 'Sumar stock al existente',
    'matModal.dupKeepEditing': 'Seguir editando',
    'matModal.offEnum': 'actual (fuera de catálogo)',
    'matModal.widthFlute': 'Ancho · dirección de fluta',

    // Soft-delete del catálogo (D-S1)
    'materials.deactivate': 'Desactivar',
    'materials.deactivateConfirm': '¿Desactivar este material? Quedará oculto del catálogo (soft-delete, sin pérdida de datos).',
    'materials.deactivated': 'Material desactivado.',
    'materials.deactivateBlocked': 'No se puede desactivar: ',
    'materials.deactivateError': 'No se pudo desactivar el material.',

    // S4c — rotación de contraseña, /novedades, /feedback
    'password.banner.title': 'Debes cambiar tu contraseña',
    'password.banner.body': 'Por seguridad, todas las cuentas renuevan su contraseña (mínimo 12 caracteres). Este aviso desaparece cuando la cambies y vuelvas a entrar.',
    'password.banner.cta': 'Cambiarla ahora en Mi Perfil',
    'password.section.title': 'Cambiar contraseña',
    'password.section.help': 'Mínimo 12 caracteres. Al guardar se cierra la sesión y entras de nuevo con la contraseña nueva.',
    'password.current': 'Contraseña actual',
    'password.new': 'Contraseña nueva',
    'password.confirm': 'Repetir contraseña nueva',
    'password.submit': 'Guardar y volver a entrar',
    'password.saving': 'Guardando…',
    'password.ok': 'Contraseña cambiada. Vuelve a iniciar sesión.',
    'password.err.tooShort': 'La contraseña nueva debe tener al menos 12 caracteres.',
    'password.err.sameAsCurrent': 'La contraseña nueva no puede ser igual a la actual.',
    'password.err.mismatch': 'Las dos contraseñas nuevas no coinciden.',
    'password.err.isEmail': 'La contraseña no puede ser tu correo.',
    'password.err.wrongCurrent': 'La contraseña actual no es correcta.',
    'password.err.weak': 'El servidor rechazó la contraseña por débil.',
    'password.err.generic': 'No se pudo cambiar la contraseña. Inténtalo de nuevo.',
    'novedades.title': 'Novedades',
    'novedades.subtitle': 'Qué cambió en el sistema y cómo se usa, por versión.',
    'novedades.howTo': 'Cómo se usa',
    'novedades.loading': 'Cargando novedades…',
    'novedades.error': 'No se pudieron cargar las novedades.',
    'novedades.showAll': 'Ver versiones anteriores',
    'feedback.title': 'Enviar comentario',
    'feedback.subtitle': 'Reporta un error, propón una mejora o pide una herramienta. Llega directo a Daniel.',
    'feedback.type': 'Tipo',
    'feedback.type.error': 'Error',
    'feedback.type.mejora': 'Mejora',
    'feedback.type.herramienta': 'Herramienta nueva',
    'feedback.titleField': 'Título',
    'feedback.titlePlaceholder': 'En una línea: qué pasa o qué necesitas',
    'feedback.detail': 'Detalle',
    'feedback.detailPlaceholder': 'Qué hiciste, qué esperabas, qué pasó. Si es un error: pantalla y trabajo (J-xxxx).',
    'feedback.page': 'Pantalla donde estabas',
    'feedback.submit': 'Enviar',
    'feedback.sending': 'Enviando…',
    'feedback.sent': 'Enviado. Gracias: queda registrado y Daniel lo recibe por correo.',
    'feedback.error': 'No se pudo enviar. Inténtalo de nuevo.',
    'feedback.err.title': 'Escribe un título (3 a 120 caracteres).',
    'feedback.err.detail': 'Escribe el detalle (hasta 4000 caracteres).',
    'nav.help': 'Ayuda',
    'nav.novedades': 'Novedades',
    'nav.feedback': 'Enviar comentario',

};

const en = {
    'materials.title': 'Materials',
    'materials.tab.materials': 'Materials',
    'materials.tab.remnants': 'Remnants',
    'materials.new': 'New Material',
    'materials.migrationLock.banner': 'Catalog under migration: creating/editing materials is temporarily disabled. Inventory counting (stock) is still available.',
    'materials.search': 'Search by name or code…',
    'materials.allCategories': 'All Categories',
    'materials.allColors': 'All Colors',
    'materials.allThicknesses': 'All Thicknesses',
    'materials.allStock': 'All Stock',
    'materials.stock.ok': 'OK',
    'materials.stock.low': 'Low',
    'materials.stock.out': 'Out of stock',
    'materials.stock.na': 'N/A',
    'materials.addStock': '+ Add stock',
    'materials.addRemnant': '+ Remnant',
    'materials.history': 'Transaction history',
    'materials.edit': 'Edit',
    'materials.delete': 'Delete',
    'materials.deleteConfirm': 'Are you sure? This cannot be undone.',
    'materials.notInList': "Not in the list? Notify the administrator",
    'materials.notInList.prompt': 'Describe the missing material (name, type, sizes):',
    'materials.notInList.sent': 'Notice sent to the administrator. Do not register the material yourself.',
    'materials.notInList.error': 'Could not send the notice.',
    'materials.movePallet': 'Move pallet',
    'materials.printLabel': 'Print label',
    'materials.empty': 'No materials match the filters.',
    'materials.loading': 'Loading…',
    'materials.view.grid': 'Grid',
    'materials.view.list': 'List',
    'materials.unit.sheets': 'sheets',
    'materials.unit.rolls': 'rolls',
    'materials.unit.units': 'units',
    'materials.col.photo': 'Photo',
    'materials.col.code': 'Code',
    'materials.col.name': 'Name',
    'materials.col.category': 'Category',
    'materials.col.presentation': 'Presentation',
    'materials.col.measures': 'Measures',
    'materials.col.thickness': 'Thickness',
    'materials.col.color': 'Color',
    'materials.col.stock': 'Stock',
    'materials.col.location': 'Location',
    'materials.col.notes': 'Notes',

    // Material label (mirror of the remnant one)
    'label.material.tag': 'MATERIAL',
    'label.stock': 'Stock',
    'label.location': 'Location',
    'label.date': 'Date',

    // Stock correction (audit-safe adjustment)
    'correct.wrong': 'Wrong quantity? Fix it',
    'correct.label': 'Correct quantity (what it should be)',
    'correct.apply': 'Apply correction',
    'correct.applying': 'Fixing…',
    'correct.done': 'Corrected to',
    'correct.invalid': 'Enter a valid quantity (≥ 0).',
    'correct.error': 'Could not apply the correction.',
    'correct.revert': 'Revert',
    'correct.revertConfirm': 'Revert this movement? A compensating adjustment will be posted (the history is kept).',

    'stock.title': 'Add stock',
    'stock.quantity': 'Quantity (sheets/units)',
    'stock.notes': 'Notes (optional)',
    'stock.save': 'Save entry',
    'stock.saving': 'Saving…',
    'stock.done': 'entry(ies) recorded at',
    'stock.error': 'Could not record the entry.',

    'remnant.title': 'New remnant',
    'remnant.material': 'Catalog material',
    'remnant.materialNone': '— No material (manual category) —',
    'remnant.category': 'Category',
    'remnant.m1': 'Measure 1 (inches)',
    'remnant.m1.flute': 'Measure 1 — FLUTE DIRECTION (inches)',
    'remnant.m2': 'Measure 2 (inches)',
    'remnant.fluteHint': 'Corrugated board: measure the piece WITH THE FLUTE along Measure 1.',
    'remnant.quantity': 'Number of pieces',
    'remnant.sourceJob': 'Source job (optional)',
    'remnant.notes': 'Notes (optional)',
    'remnant.photo': 'Photo (optional)',
    'remnant.downloadDxf': 'Download DXF',
    'remnant.save': 'Save to inventory',
    'remnant.saving': 'Saving…',
    'remnant.saved': 'Remnant saved:',
    'remnant.printLabel': 'Print label',
    'remnant.close': 'Close',
    'remnant.cancel': 'Cancel',
    'remnant.error': 'Could not save the remnant.',
    'remnant.invalidDims': 'Enter Measure 1 and Measure 2 (inches, > 0).',
    'remnant.flute.badge': 'Flute → M1',
    'remnant.status.available': 'Available',
    'remnant.status.reserved': 'Reserved',
    'remnant.status.used': 'Used',
    'remnant.use': 'Use',
    'remnant.useJobPrompt': 'Which job used it? (optional, e.g. J-1042)',
    'remnant.search': 'Search by code or material…',
    'remnant.allStatuses': 'All statuses',
    'remnant.allLocations': 'All locations',
    'remnant.col.code': 'Code',
    'remnant.col.material': 'Material',
    'remnant.col.measures': 'Measures (in)',
    'remnant.col.qty': 'Qty',
    'remnant.col.location': 'Location',
    'remnant.col.status': 'Status',
    'remnant.col.actions': 'Actions',
    'remnant.totals': 'Totals by category:',
    'remnant.empty': 'No remnants registered yet.',

    'location.label': 'Location',
    'location.type.pallet': 'Pallet',
    'location.type.rack': 'Rack',
    'location.type.zone': 'Floor zone',
    'location.warehouse': 'Warehouse',
    'location.pick.pallet': 'Pick the pallet…',
    'location.pick.rack': 'Pick the rack…',
    'location.pick.zone': 'Pick the zone…',
    'location.missing': 'Select the location from the list.',
    'location.noneConfigured': 'No locations configured. Ask the administrator to create warehouses/racks/zones.',
    'location.noPallets': 'No pallets created yet. Use Rack or Zone, or create a pallet from "Move pallet".',

    'pallet.move.title': 'Move pallet',
    'pallet.move.which': 'Pallet',
    'pallet.move.pick': 'Pick the pallet…',
    'pallet.move.to': 'New location',
    'pallet.move.save': 'Move',
    'pallet.move.moving': 'Moving…',
    'pallet.move.done': 'Pallet relocated. Everything on it moved along.',
    'pallet.move.error': 'Could not move the pallet.',
    'pallet.move.firstPallet': 'No pallets yet. Pick a zone or rack below and create the first one with "+ New pallet".',
    'pallet.new': 'New pallet',
    'pallet.new.prompt': 'A new pallet will be created at the chosen location.',
    'pallet.new.hint': 'Pick a zone or rack above to enable "+ New pallet".',
    'pallet.new.done': 'Pallet created:',
    'pallet.qr.download': 'Download pallet QR',

    // Operator Terminal (PLAN-TERMINAL-OPERADOR W2 · B1c)
    'terminal.title': 'Operator Terminal',
    'terminal.subtitle': 'Scan a plate to record production',
    'terminal.input.placeholder': 'Scan the QR or type the plate code…',
    'terminal.scanCamera': 'Scan with camera',
    'terminal.searching': 'Searching…',
    'terminal.cameraTitle': 'Point the camera at the QR',
    'terminal.cameraClose': 'Close camera',
    'terminal.next': 'Scan another',
    'terminal.exit': 'Exit',
    'terminal.logout': 'Sign out',
    'terminal.job': 'Job',
    'terminal.preview': 'Plate preview',
    'terminal.action.prompt': 'Which action are you recording?',
    'terminal.printedFront': 'Printed (Front)',
    'terminal.printed': 'Printed',
    'terminal.printedBack': 'Printed (Back)',
    'terminal.cutLabel': 'Cut',
    'terminal.markPrintFront': 'Printed (Front)',
    'terminal.markPrint': 'Mark Printed',
    'terminal.markPrintBack': 'Printed (Back)',
    'terminal.markCut': 'Mark Cut',
    'terminal.reportFailure': 'Report Failure / Shortage',
    'terminal.allMarked': 'All repetitions are already marked.',
    'terminal.piecesInSheet': 'Pieces on this plate',
    'terminal.success.print': 'Done! 1 repetition marked as printed (front).',
    'terminal.success.printBack': 'Done! 1 repetition marked as printed (back).',
    'terminal.success.cut': 'Done! 1 repetition marked as cut.',
    'terminal.success.report': 'Report sent and assigned.',
    'terminal.error.generic': 'Could not record production.',
    'terminal.error.notfound': 'No plate or piece found with that code.',
    'terminal.error.artifact': 'That is a FILE label. Use it in the File Finder.',
    'terminal.error.unknown': 'Code not recognized. Scan a plate or piece QR.',
    'terminal.error.sheetGone': 'The plate for that code no longer exists.',
    'terminal.candidates.sheets': 'Several plates match. Pick one:',
    'terminal.candidates.pieces': 'The piece is in several jobs. Pick one:',
    'terminal.piece.title': 'Piece (lookup)',
    'terminal.piece.required': 'Required',
    'terminal.piece.printed': 'Printed',
    'terminal.piece.cut': 'Cut',
    'terminal.piece.status': 'Status',
    'terminal.piece.inSheets': 'On plates',
    'terminal.piece.readonly': 'Read-only view. Production is recorded by scanning the PLATE.',

    // Material catalog — attributes by family (PLAN-CATALOGO-MATERIALES §3 · Slice 1)
    'matAttr.presentation': 'Presentation',
    'matAttr.dimensions': 'Dimensions',
    'matAttr.brand': 'Brand',
    'matAttr.supplier': 'Supplier',
    'matAttr.price': 'Price',
    'matAttr.imageUrl': 'Image',
    'matAttr.flute': 'Flute',
    'matAttr.test': 'Test / ECT',
    'matAttr.outerLiner': 'Outer liner',
    'matAttr.innerLiner': 'Inner liner',
    'matAttr.medium': 'Medium (center)',
    'materials.tx.consumption': 'Consumption Out',
    'matAttr.coating': 'Coating',
    'matAttr.caliper': 'Caliper (PT)',
    'matAttr.color': 'Color',
    'matAttr.thickness': 'Thickness',
    'matAttr.subtype': 'Subtype',
    'matAttr.type': 'Type',
    'matAttr.finish': 'Finish',
    'matAttr.outerFace': 'Outer face',
    'matAttr.coreFace': 'Core (honeycomb) face',
    'matAttr.innerFace': 'Inner face',
    // Material catalog — families (categories) — 6 families §3.2
    'matCat.CORRUGATED': 'Corrugated',
    'matCat.HONEYCOMB': 'Honeycomb',
    'matCat.RIGID': 'Rigid sheet',
    'matCat.FLUTED_PLASTIC': 'Fluted plastic',
    'matCat.PAPERBOARD': 'Paperboard',
    'matCat.WOOD': 'Wood',
    // Material catalog — validation messages
    'matValid.unknownCategory': 'Unknown category.',
    'matValid.required': 'Required field.',
    'matValid.enum': 'Value not allowed.',
    'matValid.range': 'Thickness is out of the family range.',
    'matValid.unit': 'Wrong thickness unit for the family.',
    'matValid.numeric': 'Must be a number.',

    // Dynamic material modal (Slice 4)
    'matModal.newTitle': 'New material',
    'matModal.editTitle': 'Edit material',
    'matModal.category': 'Category',
    'matModal.width': 'Width',
    'matModal.height': 'Height / Length',
    'matModal.previewTitle': 'Preview (generated by the server)',
    'matModal.code': 'Code',
    'matModal.codeAuto': '(assigned on save)',
    'matModal.displayName': 'Name',
    'matModal.specCode': 'Spec code',
    'matModal.save': 'Save material',
    'matModal.saving': 'Saving…',
    'matModal.cancel': 'Cancel',
    'matModal.imageHint': '…or paste an image (Ctrl+V) in this window.',
    'matModal.dupTitle': 'A material with this identity already exists.',
    'matModal.dupStock': 'stock',
    'matModal.dupAddStock': 'Add stock to existing',
    'matModal.dupKeepEditing': 'Keep editing',
    'matModal.offEnum': 'current (off-catalog)',
    'matModal.widthFlute': 'Width · flute direction',

    // Catalog soft-delete (D-S1)
    'materials.deactivate': 'Deactivate',
    'materials.deactivateConfirm': 'Deactivate this material? It will be hidden from the catalog (soft-delete, no data loss).',
    'materials.deactivated': 'Material deactivated.',
    'materials.deactivateBlocked': 'Cannot deactivate: ',
    'materials.deactivateError': 'Could not deactivate the material.',

    // S4c — password rotation, /novedades, /feedback
    'password.banner.title': 'You must change your password',
    'password.banner.body': 'For security, every account renews its password (12 characters minimum). This notice disappears once you change it and sign in again.',
    'password.banner.cta': 'Change it now in My Profile',
    'password.section.title': 'Change password',
    'password.section.help': 'At least 12 characters. Saving signs you out; sign in again with the new password.',
    'password.current': 'Current password',
    'password.new': 'New password',
    'password.confirm': 'Repeat new password',
    'password.submit': 'Save and sign in again',
    'password.saving': 'Saving…',
    'password.ok': 'Password changed. Please sign in again.',
    'password.err.tooShort': 'The new password must have at least 12 characters.',
    'password.err.sameAsCurrent': 'The new password cannot be the same as the current one.',
    'password.err.mismatch': 'The two new passwords do not match.',
    'password.err.isEmail': 'The password cannot be your email.',
    'password.err.wrongCurrent': 'The current password is not correct.',
    'password.err.weak': 'The server rejected the password as too weak.',
    'password.err.generic': 'Could not change the password. Please try again.',
    'novedades.title': "What's new",
    'novedades.subtitle': 'What changed in the system and how to use it, by version.',
    'novedades.howTo': 'How to use it',
    'novedades.loading': 'Loading updates…',
    'novedades.error': 'Could not load the updates.',
    'novedades.showAll': 'Show older versions',
    'feedback.title': 'Send feedback',
    'feedback.subtitle': 'Report a bug, propose an improvement or request a tool. It goes straight to Daniel.',
    'feedback.type': 'Type',
    'feedback.type.error': 'Bug',
    'feedback.type.mejora': 'Improvement',
    'feedback.type.herramienta': 'New tool',
    'feedback.titleField': 'Title',
    'feedback.titlePlaceholder': 'One line: what happens or what you need',
    'feedback.detail': 'Details',
    'feedback.detailPlaceholder': 'What you did, what you expected, what happened. For bugs: screen and job (J-xxxx).',
    'feedback.page': 'Screen you were on',
    'feedback.submit': 'Send',
    'feedback.sending': 'Sending…',
    'feedback.sent': 'Sent. Thanks: it is logged and Daniel gets it by email.',
    'feedback.error': 'Could not send. Please try again.',
    'feedback.err.title': 'Write a title (3 to 120 characters).',
    'feedback.err.detail': 'Write the details (up to 4000 characters).',
    'nav.help': 'Help',
    'nav.novedades': "What's new",
    'nav.feedback': 'Send feedback',

};

const DICTS = { es, en };

// Idioma activo: español (el de la app hoy). El switch real llega con react-i18next.
let lang = 'es';

/** Cambia el idioma activo (lo usará el switch ES/EN cuando exista). */
export function setLanguage(l) { if (DICTS[l]) lang = l; }

/** Traduce una clave; cae a español y por último a la clave (visible para QA). */
export function t(key) {
    return DICTS[lang][key] ?? es[key] ?? key;
}

/** Traduce en un idioma concreto (banner bilingüe ES+EN sin switch global). */
export function tIn(l, key) {
    return (DICTS[l] || es)[key] ?? es[key] ?? key;
}

/** Claves de un idioma (introspección para tests de paridad es/en). */
export function languageKeys(l) {
    return Object.keys(DICTS[l] || {});
}
